import styled from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import { fontSize } from '../../../../DashboardSettings.styles'

export const Wrapper = styled.div``

export const BottomButtonRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

export const AddButtonText = styled.p`
  font-size: ${fontSize.small};
  color: ${props => props.disabled ? colors.grey : colors.orange};
  vertical-align: middle;
  padding-left: 10px;
  cursor: pointer;
`

export const HelperText = styled(AddButtonText)`
  font-size: 14px;
  color: ${colors.darkTeal};
  width: 400px;

  @media (max-width: 950px) {
    width: 265px;
  }
`
